/* lib/licence-expired/licence-expired.component.scss */
.logo {
  width: 150px;
}
.expired-message {
  color: var(--ion-color-primary);
}
/*# sourceMappingURL=licence-expired.component.css.map */
